import { Observable } from "rxjs";
import { apiService } from "../../ApiService";
import { Plan } from "../../../model/Plan";

/** @deprecated use getPlan */
export const getPlanById = (id: string): Observable<Plan> => {
  return apiService.get({
    path: `v1/plan/${id}`,
  });
};
